import React from "react"
import { Row, Col } from "@bootstrap-styled/v4"
import WOW from "react-wow"
import { Star } from "@styled-icons/boxicons-solid/Star"

import * as S from "./styled"

const DepoimentosSlider = ({ items }) => {
  return (
    <S.DepoimentosSliderWrapper>
      <S.MasonryGrid>
        {items.map((item, i) => (
          <S.MasonryItem key={i}>
            <WOW animation="fadeInUp" data-delay="0.3s">
              <S.DepoimentosItem>
                <S.DepoimentosItemDesc>
                  {item.node.frontmatter.description}
                </S.DepoimentosItemDesc>
                <S.DepoimentosItemAuthor>
                  - {item.node.frontmatter.author}
                </S.DepoimentosItemAuthor>
                <S.DepoimentosItemPosition>
                  {item.node.frontmatter.title}
                </S.DepoimentosItemPosition>
                <S.DepoimentosStars>
                  <Star />
                  <Star />
                  <Star />
                  <Star />
                  <Star />
                </S.DepoimentosStars>
              </S.DepoimentosItem>
            </WOW>
          </S.MasonryItem>
        ))}
      </S.MasonryGrid>
      <S.MasonryItem className="full-width">
        <WOW animation="fadeInUp" data-delay="0.3s">
          <S.DepoimentosItem>
            <S.DepoimentosItemDesc>
              "Ter escolhido a Evolve para fazer o nosso novo site foi uma
              decisão muito acertada. Confesso que o resultado ficou acima da
              expectativa. Tudo foi desenhado e projetado com muito primor, os
              prazos foram cumpridos conforme acordado e o resultado final
              impressionou. Além da qualidade final do site, o atendimento
              durante todo o projeto foi sensacional. Indico a Evolve sem medo
              algum! Com certeza iremos fazer mais projetos juntos no futuro."
            </S.DepoimentosItemDesc>
            <S.DepoimentosItemAuthor>- Lucas Teófilo</S.DepoimentosItemAuthor>
            <S.DepoimentosItemPosition>COO Eduqhub</S.DepoimentosItemPosition>
            <S.DepoimentosStars>
              <Star />
              <Star />
              <Star />
              <Star />
              <Star />
            </S.DepoimentosStars>
          </S.DepoimentosItem>
        </WOW>
      </S.MasonryItem>
    </S.DepoimentosSliderWrapper>
  )
}

export default DepoimentosSlider
